import { render, staticRenderFns } from "./CascaderArea.vue?vue&type=template&id=65b42ddb&scoped=true"
import script from "./CascaderArea.vue?vue&type=script&lang=js"
export * from "./CascaderArea.vue?vue&type=script&lang=js"
import style0 from "./CascaderArea.vue?vue&type=style&index=0&id=65b42ddb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b42ddb",
  null
  
)

export default component.exports